// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ErrorBoundary_wrap__OaYYg"};